import { render, staticRenderFns } from "./ConsignacaoMenu.vue?vue&type=template&id=cb3db5fc&scoped=true&"
import script from "./ConsignacaoMenu.vue?vue&type=script&lang=js&"
export * from "./ConsignacaoMenu.vue?vue&type=script&lang=js&"
import style0 from "./ConsignacaoMenu.vue?vue&type=style&index=0&id=cb3db5fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3db5fc",
  null
  
)

export default component.exports